import { connect } from 'react-redux';
import { isLoading } from 'helpers';
import {
  loadMaCisCreator,
  removeMaCisFiltersCreator,
  setMaCisFiltersCreator,
  setMaCisPageCreator,
  setMaCisPerPageCreator,
  setMaCisProfileCreator,
  setMaCisSortCreator,
  loadGlobalCisCertificatesAttributesCreator,
  removeMaCisCreator,
} from '../../../../store/actionsCreators';
import Certificates from '../../../../shared/Cis/Certificates/Certificates';

const mapStateToProps = ({ loading, ma, globals, user }) => ({
  loading: isLoading(loading, 'LOAD_MA_CIS'),
  type: 'ma',
  list: ma.cis.certificates,
  countries: globals.countries,
  certificationBodies: globals.cis.certificationBodies,
  userPermissions: user.userPermissions,
  levelDomains: globals.cis.levelDomains,
  languages: globals.languages,
  levelDomainsLevels: globals.cis.levelDomainsLevels,
  levelDomainsDomains: globals.cis.levelDomainsDomains,
  organizations: globals.cis.organizations,
});

const mapDispatchToProps = (dispatch) => ({
  loadList: () => dispatch(loadMaCisCreator('certificates')),
  setPage: (payload) => dispatch(setMaCisPageCreator('certificates', payload)),
  setPerPage: (payload) => dispatch(setMaCisPerPageCreator('certificates', payload)),
  setSort: (payload) => dispatch(setMaCisSortCreator('certificates', payload)),
  setFilters: (payload) => dispatch(setMaCisFiltersCreator('certificates', payload)),
  removeFilters: () => dispatch(removeMaCisFiltersCreator('certificates')),
  setProfile: (payload) => dispatch(setMaCisProfileCreator('certificates', payload)),
  removeCertificate: (payload) => dispatch(removeMaCisCreator('certificates', payload)),
  loadCertificatesAttributes: () => dispatch(loadGlobalCisCertificatesAttributesCreator()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Certificates);
